
import React from 'react';
import './CourseDetailPage.css'; // Make sure to create and link this CSS file
import { useNavigate } from 'react-router-dom';
import backgroundImage from '../../assets/bgpremium.jpg'; // Adjust the path to your image



const CourseDetailPage = () => {
    const navigate = useNavigate();

    const handleEnrollClick = () => {
        navigate('/imat-course'); // Use navigate instead of window.location.href
    };

    return (
        <div className="course-detail-container"
        style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
        }}>
            {/* Left Section - Course Details */}
            <div className="course-description">
                <h5>IMAT Meditalia Prep Course (€129) – 3 Months</h5>
                <p>March 2025 (3 months)</p>
                <ul>
                    <li>Mock tests every two weeks with ranking</li>
                    <li>12 MedItalia simulations on website</li>
                    <li>Access to previous papers online simulators.</li>
                    <li>Career counseling sessions available</li>
                </ul>
                <button className="buy-button" onClick={handleEnrollClick}>Enroll Now</button>
            </div>

            {/* Right Section - Course Description */}
            <div className="course-description">
                <h2>About the Course</h2>
                <p>
                    This 3-month course is designed to help students prepare effectively for the IMAT exam with structured practice and expert guidance.
                </p>
                <h3>What’s Included?</h3>
                <ul>
                    <li>
                        <strong>Mock Tests Every Two Weeks</strong> – Regular full-length tests with ranking to track progress and improve time management.
                    </li>
                    <li>
                        <strong>12 MedItalia Simulations</strong> – Exclusive IMAT-style exams created by Future MedsAcademy to help students practice under real exam conditions.
                    </li>
                    <li>
                        <strong>Access to Previous Papers & Online Simulators</strong> – Practice with past IMAT papers and interactive online simulators to strengthen understanding.
                    </li>
                    <li>
                        <strong>Career Counseling Sessions</strong> – Expert guidance on university selection, applications, and future career paths.
                    </li>
                </ul>
                <p>
                    This course is ideal for students seeking an affordable and structured approach to IMAT preparation!
                </p>
            </div>
        </div>
    );
};

export default CourseDetailPage;



















// import React from 'react';
// import './CourseDetailPage.css'; // Make sure to create and link this CSS file

// const CourseDetailPage = () => {
//     return (
//         <div className="course-detail-container">
//             <div className="course-detail-card">
//                 <h1>IMAT Meditalia Prep Course
//                 (€129) – 3 Months</h1>
//                 <p>February 2025 (3 months)</p>
//                 <ul>
//                     <li>Mock tests every two weeks with ranking</li>
//                     <li>12 MedItalia simulations on website</li>
//                     <li>Access to previous papers online simulators.</li>
//                     <li>Career counseling sessions available</li>
//                 </ul>
//                 <button className="buy-button">Buy</button>
//             </div>
//         </div>
//     );
// };

// export default CourseDetailPage;









